import styled from 'styled-components'
import * as Icon from 'components/atoms/Icon/Icon.styles'

export const Root = styled.div`
  padding: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;

  & > ${ Icon.IconContainer } {
    font-size: 14px;
    padding-right: 5px;

    :before {
      transition: 0.3s transform ease-out;
      transform: rotate(0deg);
    }
  }

  &:hover
    > ${ Icon.IconContainer }:before,
    &.openAll:hover
    > ${ Icon.IconContainer }:before {
    transform: rotate(-90deg);
  }

  &.openAll > ${ Icon.IconContainer }:before {
    transform: rotate(-180deg);
  }

  @media print {
    display: none;
  }
`

export const Link = styled.span`
  text-decoration: underline;
`
